<section class="file-explorer-wrapper">
  <rappider-alert [type]="alertConfig.type"
                  [title]="alertConfig.title"
                  [description]="alertConfig.description"
                  [closeable]="alertConfig.closeable"
                  [showIcon]="alertConfig.showIcon"></rappider-alert>
  <rappider-list-grid [config]="listGridConfig"
                      [data]="activeEntityData"
                      [loading]="loading"
                      [enableRowPointer]="listGridConfig?.enableRowPointer"
                      [selectAndMark]="listGridConfig?.selectAndMark"
                      [searchButtonActive]="listGridConfig?.searchButtonActive"
                      [searchActive]="listGridConfig?.searchActive"
                      (searchTextChangeOnButtonClick)="onSearchTextChange($event)"
                      (rowActionClick)="onRowActionClick($event)"
                      (selectionChange)="onSelectionChange($event)"
                      (overflowlistItemClick)="onOverflowlistItemClick($event)"></rappider-list-grid>
  <section *ngIf="editFormVisible && !isModalActive">
    <rappider-crud-view-edit-form [config]="editFormConfig"
                                  (formValueChange)="onFormValueChange($event)">
    </rappider-crud-view-edit-form>
  </section>
  <div *ngIf="buttonConfig?.visible !== false"
        class="button-wrapper">
    <rappider-button [redirectUrl]="buttonConfig?.redirectUrl"
                    [redirectTarget]="buttonConfig?.redirectTarget"
                    [key]="buttonConfig?.key"
                    [type]="buttonConfig?.type"
                    [shape]="buttonConfig?.shape"
                    [text]="buttonConfig?.text"
                    [size]="buttonConfig?.size"
                    [transparent]="buttonConfig?.transparent"
                    [loading]="buttonConfig?.loading"
                    [block]="buttonConfig?.block"
                    [disabled]="buttonConfig?.disabled"
                    [colorType]="buttonConfig?.colorType"
                    [icon]="buttonConfig?.icon"
                    [popconfirmTitle]="buttonConfig?.popconfirmTitle"
                    [emitWithoutPopconfirm]="buttonConfig?.emitWithoutPopconfirm"
                    [popconfirmCancelText]="buttonConfig?.popconfirmCancelText"
                    [popconfirmOkText]="buttonConfig?.popconfirmOkText"
                    [popconfirmOkDanger]="buttonConfig?.popconfirmOkDanger"
                    [popconfirmPlacement]="buttonConfig?.popconfirmPlacement"
                    [iconPlacement]="buttonConfig?.iconPlacement"
                    [formButtonType]="buttonConfig?.formButtonType"
                    [borderSettings]="buttonConfig?.borderSettings"
                    [marginSettings]="buttonConfig?.marginSettings"
                    [paddingSettings]="buttonConfig?.paddingSettings"
                    [shadowSettings]="buttonConfig?.shadowSettings"
                    [customColorSettings]="buttonConfig?.customColorSettings"
                    [customSizeSettings]="buttonConfig?.customSizeSettings"
                    [tooltipText]="buttonConfig?.tooltipText"
                    [tooltipPlacement]="buttonConfig?.tooltipPlacement"
                    [elementId]="buttonConfig?.elementId"
                    [customCssClass]="buttonConfig?.customCssClass"
                    (confirm)="onConfirm()"
                    (popconfirmCancel)="onPopconfirmCancel()"
                    (click)="onClick()"></rappider-button>
  </div>
</section>
<rappider-modal *ngIf="editFormVisible && isModalActive"
                [visible]="modalVisibility"
                [title]="modalConfig?.title"
                [okText]="modalConfig?.okText"
                [cancelText]="modalConfig?.cancelText"
                [width]="modalConfig?.width"
                [okDisabled]="modalConfig?.okDisabled"
                [cancelDisabled]="modalConfig?.cancelDisabled"
                [footer]="modalConfig?.footer"
                [okLoading]="modalConfig?.okLoading"
                [okDanger]="modalConfig?.okDanger"
                [mask]="modalConfig?.mask"
                [maskClosable]="modalConfig?.maskClosable"
                [className]="modalConfig?.className"
                [bodyStyle]="modalConfig?.bodyStyle"
                [fullScreen]="modalConfig?.fullScreen"
                [closeIconVisibility]="modalConfig?.closeIconVisibility"
                (okClick)="onModalSelectClick()"
                (visibleChange)="onModalVisibleChange($event)"
                (afterModalOpen)="onModalAfterModalOpen()"
                (cancelClick)="onModalCancelClick()">
  <rappider-crud-view-edit-form [config]="editFormConfig"
                                (formValueChange)="onFormValueChange($event)">
  </rappider-crud-view-edit-form>
</rappider-modal>
